import * as tracking from 'dibs-tracking';
import SV from 'server-vars';

export const initializeTracking = (): void => {
    const userData = SV.get('userData') || {};
    tracking.addUserAttributes({
        userID: userData?.serviceId,
        userEmailAddress: userData?.profile?.email,
    });
};
